/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    data : null,
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.RecruitScreener.REQUEST_RECRUITS_SCREENER_DATA:
      return {
        ...state,
    };
    case actions.RecruitScreener.RECRUITS_SCREENER_DATA_RECEIVED:
          return{
      ...state,
      data : action.data.RespondentScreenerResponses,
      // userid: action.payload.user_ID,
      // projectid: action.payload.project_ID,
    };

    default:
      return state;
  }
};

export default reducer;
